import "./../../../../pages/audit complet/simulation/simulation.css";
import "./DroitsSuccession.css";
import "../../AuditComplet/ContexteFiscal/ContexteFiscal.css";
import { useState, useContext, useEffect } from "react";
import { FaPrint, FaSave, FaUndo, FaCalculator, FaArrowLeft, FaBalanceScale } from "react-icons/fa";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import _ from "lodash";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { useStudyManagementHandlers } from "pages/studyManagementHandler";
import { SyntheseDroitsSuccession } from "components/app/Api/Rapport/ApiRapport";
import { GetBaremeDroitsSuccession } from "components/app/Api/ApiSimulateur";

// PHP encode null pour les tranches sans plafond → on les convertit en Infinity
function normaliserBareme(baremeData) {
  return baremeData.map((entry) => ({
    ...entry,
    tranches: entry.tranches.map((t) => ({
      ...t,
      partTaxable: t.partTaxable === null ? Infinity : t.partTaxable,
    })),
  }));
}

function calculerAbattementBase(lien, representation, nombreRepresentants, abattementRepresentation) {
  if (representation === "oui" && abattementRepresentation[lien.id] !== undefined) {
    const n = Math.max(1, Number(nombreRepresentants) || 1);
    return Math.round(abattementRepresentation[lien.id] / n);
  }
  return lien.abattement;
}

function calculerDroitsSuccession(lienParenteId, actifNet, handicap, fsCohabitation, fsCelibataire, fsInfirmite, representation, nombreRepresentants, bareme) {
  const vide = { exonere: false, message: "", abattementBase: 0, abattementHandicap: 0, abattementTotal: 0, baseTaxable: 0, tranches: [], totalDroits: 0 };
  if (!bareme) return vide;

  const id = Number(lienParenteId);
  const montant = Number(actifNet) || 0;
  const { liensParente, baremeData, constants } = bareme;
  const lien = liensParente.find((l) => l.id === id);
  if (!lien) return vide;

  if (lien.degre === 0) {
    return {
      exonere: true,
      message: "Exonération totale — Époux(se) / partenaire de PACS (loi du 21 août 2007)",
      abattementBase: montant,
      abattementHandicap: 0,
      abattementTotal: montant,
      baseTaxable: 0,
      tranches: [],
      totalDroits: 0,
    };
  }

  if (id === 10 && fsCohabitation === "oui" && fsCelibataire === "oui" && fsInfirmite === "oui") {
    return {
      exonere: true,
      message: "Exonération totale — Frère / sœur (conditions art. 796-0 ter CGI remplies)",
      abattementBase: montant,
      abattementHandicap: 0,
      abattementTotal: montant,
      baseTaxable: 0,
      tranches: [],
      totalDroits: 0,
    };
  }

  const abattementBase = calculerAbattementBase(lien, representation, nombreRepresentants, constants.abattementRepresentation);
  const abattementHandicap = handicap === "oui" ? constants.abattementHandicap : 0;
  const abattementTotal = abattementBase + abattementHandicap;
  const baseTaxable = Math.max(0, montant - abattementTotal);

  // Neveu/nièce par représentation : prend la place du frère/sœur (degré 2)
  const degreEffectif = id === 11 && representation === "oui" ? 2 : lien.degre;
  const baremeEntry = baremeData.find((b) => b.ligneFamiliale === lien.ligneFamiliale && degreEffectif >= b.degreMin && degreEffectif <= b.degreMax);
  if (!baremeEntry) return { ...vide, abattementBase, abattementHandicap, abattementTotal, baseTaxable };

  let totalDroits = 0;
  let restant = baseTaxable;
  const tranches = [];

  for (const tranche of baremeEntry.tranches) {
    if (restant <= 0) break;
    const partDansTranche = tranche.partTaxable === Infinity ? restant : Math.min(restant, tranche.partTaxable);
    if (partDansTranche > 0) {
      const droitsTranche = (partDansTranche * tranche.taux) / 100;
      tranches.push({ taux: tranche.taux, base: partDansTranche, droits: droitsTranche });
      totalDroits += droitsTranche;
      restant -= partDansTranche;
    }
  }

  return { exonere: false, message: "", abattementBase, abattementHandicap, abattementTotal, baseTaxable, tranches, totalDroits };
}

const DroitsSuccession = (props) => {
  const context = useContext(AppContext);
  const { handleSave, handleGoToAudits } = useStudyManagementHandlers(props);

  const initialValues = {
    DroitsSuccessionLienParenteId: 2,
    DroitsSuccessionActifNet: 0,
    DroitsSuccessionHandicap: "non",
    DroitsSuccessionFSCohabitation: "non",
    DroitsSuccessionFSCelibataire: "non",
    DroitsSuccessionFSInfirmite: "non",
    DroitsSuccessionRepresentation: "non",
    DroitsSuccessionNombreRepresentants: 1,
  };

  const initialResultat = { exonere: false, message: "", abattementBase: 0, abattementHandicap: 0, abattementTotal: 0, baseTaxable: 0, tranches: [], totalDroits: 0 };

  const [bareme, setBareme] = useState(null);
  const [values, setValues] = useState(initialValues);
  const [resultat, setResultat] = useState(initialResultat);

  useEffect(() => {
    const NewValues = {
      DroitsSuccessionLienParenteId: context.state.DroitsSuccessionLienParenteId,
      DroitsSuccessionActifNet: context.state.DroitsSuccessionActifNet,
      DroitsSuccessionHandicap: context.state.DroitsSuccessionHandicap,
      DroitsSuccessionFSCohabitation: context.state.DroitsSuccessionFSCohabitation,
      DroitsSuccessionFSCelibataire: context.state.DroitsSuccessionFSCelibataire,
      DroitsSuccessionFSInfirmite: context.state.DroitsSuccessionFSInfirmite,
      DroitsSuccessionRepresentation: context.state.DroitsSuccessionRepresentation,
      DroitsSuccessionNombreRepresentants: context.state.DroitsSuccessionNombreRepresentants,
    };
    setValues(NewValues);

    GetBaremeDroitsSuccession().then((data) => {
      if (!data || !data.liensParente) return;
      const baremeNormalise = { ...data, baremeData: normaliserBareme(data.baremeData) };
      setBareme(baremeNormalise);
      const res = calculerDroitsSuccession(
        NewValues.DroitsSuccessionLienParenteId,
        NewValues.DroitsSuccessionActifNet,
        NewValues.DroitsSuccessionHandicap,
        NewValues.DroitsSuccessionFSCohabitation,
        NewValues.DroitsSuccessionFSCelibataire,
        NewValues.DroitsSuccessionFSInfirmite,
        NewValues.DroitsSuccessionRepresentation,
        NewValues.DroitsSuccessionNombreRepresentants,
        baremeNormalise
      );
      setResultat(res);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCalcul = (Property, value) => {
    context.handleValueChange(Property, value);
    const NewValues = _.cloneDeep(values);
    NewValues[Property] = value;
    setValues(NewValues);
    const res = calculerDroitsSuccession(
      Number(NewValues.DroitsSuccessionLienParenteId),
      Number(NewValues.DroitsSuccessionActifNet),
      NewValues.DroitsSuccessionHandicap,
      NewValues.DroitsSuccessionFSCohabitation,
      NewValues.DroitsSuccessionFSCelibataire,
      NewValues.DroitsSuccessionFSInfirmite,
      NewValues.DroitsSuccessionRepresentation,
      NewValues.DroitsSuccessionNombreRepresentants,
      bareme
    );
    setResultat(res);
    context.handleValueChange("DroitsSuccessionResultat", res);
  };

  const lienId = Number(values.DroitsSuccessionLienParenteId);
  const showFrereSoeurConditions = lienId === 10;
  const showRepresentation = lienId === 5 || lienId === 11;
  const showNombreRepresentants = showRepresentation && values.DroitsSuccessionRepresentation === "oui";
  const abattementRepresentation = bareme?.constants?.abattementRepresentation?.[lienId] ?? 0;
  const abattementHandicap = bareme?.constants?.abattementHandicap ?? 159325;

  const liensParenteOptions = bareme ? bareme.liensParente.map((l) => ({ value: l.id, label: l.label })) : [{ value: 2, label: "Chargement…" }];

  return (
    <>
      <Column fill>
        <Row style={{ alignItems: "stretch" }} className="droits-succession-layout">
          {/* Colonne gauche : paramètres */}
          <Column fill style={{ minWidth: "640px", maxWidth: "820px", display: "flex", flexDirection: "column" }} className="droits-succession-left-column">
            <CardBox className="blockRoundedForce" bpad style={{ flex: 1, padding: "25px" }}>
              <div className="revenuspro-container" style={{ paddingLeft: "0px" }}>
                <div className="dossier-header" style={{ marginBottom: "15px" }}>
                  <div className="dossier-header-icon">
                    <FaBalanceScale />
                  </div>
                  <h1 className="dossier-header-title">Droits de succession</h1>
                </div>

                <div className="header-card">
                  <div className="category-column" style={{ textAlign: "left", flex: 2 }}>
                    Paramètres
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    Valeurs
                  </div>
                </div>

                <div className="card-list-container">
                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">👨‍👩‍👧</div>
                      Lien de parenté avec le défunt
                    </div>
                    <div className="value-column">
                      <DropDown
                        value={values.DroitsSuccessionLienParenteId}
                        onChange={(e) => handleCalcul("DroitsSuccessionLienParenteId", e.target.value)}
                        options={liensParenteOptions}
                        style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">💰</div>
                      Actif net successoral
                    </div>
                    <div className="value-column">
                      <TextField
                        value={values.DroitsSuccessionActifNet}
                        onChange={(e) => handleCalcul("DroitsSuccessionActifNet", e.target.value)}
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">♿</div>
                      Héritier en situation de handicap
                    </div>
                    <div className="value-column">
                      <DropDown
                        value={values.DroitsSuccessionHandicap}
                        onChange={(e) => handleCalcul("DroitsSuccessionHandicap", e.target.value)}
                        options={[
                          { value: "non", label: "Non" },
                          { value: "oui", label: `Oui (+${applyFormat(abattementHandicap, "uint", { thousands: " ", unit: " €" })})` },
                        ]}
                      />
                    </div>
                  </div>

                  {showFrereSoeurConditions && (
                    <>
                      <div className="card" style={{ backgroundColor: "#fffbeb", borderColor: "#fcd34d" }}>
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">ℹ️</div>
                          <span style={{ fontSize: "12px", color: "#92400e" }}>
                            Exonération totale si les <strong>3 conditions</strong> ci-dessous sont remplies (art. 796-0 ter CGI)
                          </span>
                        </div>
                      </div>

                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">🏠</div>
                          <div>
                            Domicile commun avec le défunt
                            <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>A vécu avec le défunt durant les 5 années précédant son décès</div>
                          </div>
                        </div>
                        <div className="value-column">
                          <DropDown
                            value={values.DroitsSuccessionFSCohabitation}
                            onChange={(e) => handleCalcul("DroitsSuccessionFSCohabitation", e.target.value)}
                            options={[
                              { value: "non", label: "Non" },
                              { value: "oui", label: "Oui" },
                            ]}
                          />
                        </div>
                      </div>

                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">💍</div>
                          <div>
                            Situation matrimoniale
                            <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>Célibataire, veuf(ve), divorcé(e) ou séparé(e) de corps au moment du décès</div>
                          </div>
                        </div>
                        <div className="value-column">
                          <DropDown
                            value={values.DroitsSuccessionFSCelibataire}
                            onChange={(e) => handleCalcul("DroitsSuccessionFSCelibataire", e.target.value)}
                            options={[
                              { value: "non", label: "Non" },
                              { value: "oui", label: "Oui" },
                            ]}
                          />
                        </div>
                      </div>

                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">🕐</div>
                          <div>
                            Âge ou infirmité
                            <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>Plus de 50 ans, ou infirmité empêchant de subvenir à ses besoins par son travail</div>
                          </div>
                        </div>
                        <div className="value-column">
                          <DropDown
                            value={values.DroitsSuccessionFSInfirmite}
                            onChange={(e) => handleCalcul("DroitsSuccessionFSInfirmite", e.target.value)}
                            options={[
                              { value: "non", label: "Non" },
                              { value: "oui", label: "Oui" },
                            ]}
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {showRepresentation && (
                    <div className="card">
                      <div className="category-column" style={{ flex: 2 }}>
                        <div className="titre-icone">🔄</div>
                        <div>
                          Héritage par représentation du parent
                          <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>
                            Du fait du décès ou de la renonciation du parent, {lienId === 5 ? "enfant" : "frère ou sœur"} du défunt
                          </div>
                        </div>
                      </div>
                      <div className="value-column">
                        <DropDown
                          value={values.DroitsSuccessionRepresentation}
                          onChange={(e) => handleCalcul("DroitsSuccessionRepresentation", e.target.value)}
                          options={[
                            { value: "non", label: "Non" },
                            { value: "oui", label: "Oui" },
                          ]}
                        />
                      </div>
                    </div>
                  )}

                  {showNombreRepresentants && (
                    <div className="card">
                      <div className="category-column" style={{ flex: 2 }}>
                        <div className="titre-icone">👥</div>
                        <div>
                          Nombre d'héritiers par représentation du même parent
                          <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>
                            L'abattement de {applyFormat(abattementRepresentation, "uint", { thousands: " ", unit: " €" })} est partagé entre eux
                          </div>
                        </div>
                      </div>
                      <div className="value-column">
                        <TextField
                          value={values.DroitsSuccessionNombreRepresentants}
                          onChange={(e) => handleCalcul("DroitsSuccessionNombreRepresentants", e.target.value)}
                          dataType="uint"
                          format={{ unit: " héritier(s)" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </CardBox>
          </Column>

          {/* Colonne droite : actions + résultats */}
          <Column fill style={{ maxWidth: "870px", display: "flex", flexDirection: "column" }} className="droits-succession-right-column">
            <CardBox bpad className="blockRoundedForce" style={{ padding: "20px", display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
              <Column fill style={{ padding: "10px 5px" }}>
                <div className="action-button-container">
                  <ActionButton
                    onClick={() => {
                      context.handleRemiseDonneeDroitsSuccession();
                      setValues(initialValues);
                      setResultat(initialResultat);
                    }}
                    icon={FaUndo}
                    title="Réinitialiser"
                    subtitle="Remettre à zéro"
                    colors={{ primary: "#3b82f6", secondary: "#1d4ed8", shadow: "rgba(59, 130, 246, 0.4)", shadowHover: "rgba(59, 130, 246, 0.6)" }}
                    decorativeIcon={{ type: "undo" }}
                  />
                  <ActionButton
                    onClick={() => SyntheseDroitsSuccession(context.state, resultat)}
                    icon={FaPrint}
                    title="Impression"
                    subtitle="Editer un PowerPoint"
                    colors={{ primary: "#11998e", secondary: "#0d7377", shadow: "rgba(17, 153, 142, 0.4)", shadowHover: "rgba(17, 153, 142, 0.6)" }}
                    decorativeIcon={{ type: "document" }}
                  />
                  {context.state.Partner === "" && (
                    <>
                      <ActionButton
                        onClick={() => handleSave()}
                        icon={FaSave}
                        title="Sauvegarder"
                        subtitle="Sauvegarder l'étude"
                        colors={{
                          primary: "rgb(124, 58, 237)",
                          secondary: "rgb(109, 40, 217)",
                          shadow: "rgba(124, 58, 237, 0.4)",
                          shadowHover: "rgba(124, 58, 237, 0.6)",
                          background: "linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(109, 40, 217) 100%)",
                        }}
                        decorativeIcon={{ type: "save" }}
                      />
                      <ActionButton
                        onClick={() => handleGoToAudits()}
                        icon={FaArrowLeft}
                        title="Quitter"
                        subtitle="Revenir aux audits"
                        colors={{ primary: "#e57373", secondary: "#c62828", shadow: "rgba(229, 115, 115, 0.4)", shadowHover: "rgba(229, 115, 115, 0.6)" }}
                        decorativeIcon={{ type: "previous" }}
                      />
                    </>
                  )}
                </div>
              </Column>
            </CardBox>

            <CardBox tpad bpad className="blockRoundedForce" style={{ marginTop: "00px", padding: "25px 25px 25px 15px" }}>
              <div className="revenuspro-container" style={{ marginBottom: "20px", paddingLeft: "0px" }}>
                <div className="dossier-header" style={{ marginBottom: "15px", paddingLeft: "0px" }}>
                  <div className="dossier-header-icon">
                    <FaCalculator />
                  </div>
                  <h1 className="dossier-header-title">Calcul des droits de succession</h1>
                </div>

                {!bareme ? (
                  <div className="card" style={{ color: "#6b7280" }}>
                    <div className="category-column">
                      <div className="titre-icone">⏳</div>Chargement du barème…
                    </div>
                  </div>
                ) : resultat.exonere ? (
                  <div className="card-list-container">
                    <div className="card" style={{ backgroundColor: "#f0fdf4", borderColor: "#86efac" }}>
                      <div className="category-column" style={{ flex: 2 }}>
                        <div className="titre-icone">✅</div>
                        <span style={{ color: "#16a34a", fontWeight: "bold" }}>{resultat.message}</span>
                      </div>
                      <div className="value-column" style={{ color: "#16a34a", fontWeight: "bold" }}>
                        0 €
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="card-list-container">
                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">🛡️</div>
                          <div>
                            Abattement applicable
                            {showNombreRepresentants && (
                              <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>
                                {applyFormat(abattementRepresentation, "uint", { thousands: " ", unit: " €" })} ÷ {Math.max(1, Number(values.DroitsSuccessionNombreRepresentants) || 1)}{" "}
                                héritier(s)
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="value-column">{applyFormat(resultat.abattementBase, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      </div>

                      {resultat.abattementHandicap > 0 && (
                        <div className="card">
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">♿</div>Abattement handicap
                          </div>
                          <div className="value-column">{applyFormat(resultat.abattementHandicap, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                      )}

                      <div className="card">
                        <div className="category-column" style={{ flex: 2 }}>
                          <div className="titre-icone">📊</div>Base taxable
                        </div>
                        <div className="value-column">{applyFormat(resultat.baseTaxable, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      </div>
                    </div>

                    {resultat.tranches && resultat.tranches.length > 0 && (
                      <>
                        <div className="header-card" style={{ marginTop: "15px" }}>
                          <div className="category-column" style={{ flex: 2, textAlign: "left" }}>
                            Tranche
                          </div>
                          <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                            Base
                          </div>
                          <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                            Taux
                          </div>
                          <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                            Droits
                          </div>
                        </div>

                        <div className="card-list-container">
                          {resultat.tranches.map((tranche, index) => (
                            <div key={index} className="card">
                              <div className="category-column" style={{ flex: 2 }}>
                                <div className="titre-icone">📋</div>Tranche à {tranche.taux}%
                              </div>
                              <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                                {applyFormat(tranche.base, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                              </div>
                              <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                                {tranche.taux}%
                              </div>
                              <div className="value-column" style={{ flex: 1, textAlign: "center" }}>
                                {applyFormat(tranche.droits, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                              </div>
                            </div>
                          ))}

                          <div className="card" style={{ fontWeight: "bold" }}>
                            <div className="category-column" style={{ flex: 2 }}>
                              <div className="titre-icone">⚖️</div>Droits de succession totaux
                            </div>
                            <div className="value-column" style={{ flex: 1, textAlign: "center" }}></div>
                            <div className="value-column" style={{ flex: 1, textAlign: "center" }}></div>
                            <div className="value-column" style={{ flex: 1, textAlign: "center", color: resultat.totalDroits > 0 ? "#dc2626" : "inherit" }}>
                              {applyFormat(resultat.totalDroits, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {(!resultat.tranches || resultat.tranches.length === 0) && (
                      <div className="card-list-container" style={{ marginTop: "15px" }}>
                        <div className="card" style={{ fontWeight: "bold" }}>
                          <div className="category-column" style={{ flex: 2 }}>
                            <div className="titre-icone">⚖️</div>Droits de succession totaux
                          </div>
                          <div className="value-column" style={{ color: "#dc2626" }}>
                            {applyFormat(resultat.totalDroits, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </CardBox>
          </Column>
        </Row>
      </Column>
    </>
  );
};

export default DroitsSuccession;
